export default "__VITE_ASSET__DmosmYdT__"